// src/hooks/useMyProfile.jsx
import { useState, useCallback, useEffect } from 'react'; //++ useCallback
import { profilesService } from '../api/profiles';

export const useMyProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar perfil al montar el hook
  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      setError(null);
      const profileData = await profilesService.getMyProfile();
      setProfile(profileData);
    } catch (err) {
      console.error('Error fetching profile:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Subir foto de perfil
  const uploadPhoto = async (file) => {
    try {
      console.log('🔄 useMyProfile - uploadPhoto iniciado');
      const updatedProfile = await profilesService.uploadPhoto(file);
      console.log('✅ useMyProfile - uploadPhoto completado');
      
      // Actualizar el estado con el perfil actualizado
      setProfile(updatedProfile);
      return updatedProfile;
    } catch (err) {
      console.error('❌ useMyProfile - uploadPhoto error:', err);
      throw err;
    }
  };

  // Subir firma digital
  const uploadSignature = async (file) => {
    try {
      console.log('🔄 useMyProfile - uploadSignature iniciado');
      const updatedProfile = await profilesService.uploadSignature(file);
      console.log('✅ useMyProfile - uploadSignature completado');
      
      // Actualizar el estado con el perfil actualizado
      setProfile(updatedProfile);
      return updatedProfile;
    } catch (err) {
      console.error('❌ useMyProfile - uploadSignature error:', err);
      throw err;
    }
  };

  // Eliminar foto de perfil
  const deletePhoto = async () => {
    try {
      console.log('🔄 useMyProfile - deletePhoto iniciado');
      const updatedProfile = await profilesService.deletePhoto();
      console.log('✅ useMyProfile - deletePhoto completado');
      
      // Actualizar el estado con el perfil actualizado
      setProfile(updatedProfile);
      return updatedProfile;
    } catch (err) {
      console.error('❌ useMyProfile - deletePhoto error:', err);
      throw err;
    }
  };

  // Eliminar firma digital
  const deleteSignature = async () => {
    try {
      console.log('🔄 useMyProfile - deleteSignature iniciado');
      const updatedProfile = await profilesService.deleteSignature();
      console.log('✅ useMyProfile - deleteSignature completado');
      
      // Actualizar el estado con el perfil actualizado
      setProfile(updatedProfile);
      return updatedProfile;
    } catch (err) {
      console.error('❌ useMyProfile - deleteSignature error:', err);
      throw err;
    }
  };

  //NUEVO METODO: Cambiar contrasena
  const changePassword = useCallback(async (passwordData) => {
    setLoading(true);
    setError(null);
    try {
      const result = await profilesService.changePassword(passwordData);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    profile,
    loading,
    error,
    changePassword, //+
    uploadPhoto,
    uploadSignature,
    deletePhoto,
    deleteSignature,
    refetch: fetchProfile,
  };
};